const id_dashboard = {
    search: { title: "cari perusahaan", placeholder: "ID Perusahaan" },
    label: {
        whs: "Gudang Saya",
        whs_req: "Permintaan Gudang",
        delivery_last: "Pengiriman Terakhir",
        itemin_last: "Barang Masuk Terakhir",
        item_best_sell: "Barang Terlaris",
        most_trans_cus: "Pelanggan Dengan Transaksi Terbanyak",

        look_all: "Lihat Semua",
    },
}

export default id_dashboard;